<template>
    <div style="background-color: #eeeeee;padding-bottom: 100px;">
        <img style="display: block;margin: 0 auto;" src="../../assets/banner3.png" alt="">
        <div class="main" style="padding-bottom: 20px">
            <ul class="Breadcrumb">
                <li>首页</li>
                <li>></li>
                <li>行业应用</li>
                <li>></li>
                <li>{{type}}</li>
            </ul>
            <div class="content">
                <div class="menu">
                    <Menu @changeBreadcrumb="changeBreadcrumb" />
                </div>
                <div class="apply">
                    <div @click="getDetail(item)" v-for="(item, index) in applyList">
                        <div class="item">
                            <img :src="item.coverImage" :alt="item.description">
                        </div>
                        <p>{{ item.name }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Menu from './compontents/menu.vue'
export default {
    components: {
        Menu
    },
    data() {
        return {
            applyList: [
                {
                    name: "基于LH32M0S3的高精度温度测量方案",
                    coverImage: require('../../assets/img14.png'),
                    description: "",
                    id:"idididididi"
                }, {
                    name: "基于LH32M0S3的高精度温度测量方案",
                    coverImage: require('../../assets/img14.png'),
                    description: "",
                    id:"idididididi"
                }, {
                    name: "基于LH32M0S3的高精度温度测量方案",
                    coverImage: require('../../assets/img14.png'),
                    description: "",
                    id:"idididididi"
                }, {
                    name: "基于LH32M0S3的高精度温度测量方案",
                    coverImage: require('../../assets/img14.png'),
                    id:"idididididi",
                    description: "",
                },
            ],
            type:""
        }
    },
    methods:{
        changeBreadcrumb(name){
            this.type = name
        },
        getDetail(item){
            this.$router.push({path:"/apply/ApplyDetail",query:{id:item.id,type:this.$route.query.id}})
        }
    }
}
</script>
<style lang="scss" scoped>
.content {
    display: flex;

    .menu {
        width: 250px;
    }

    .apply {
        overflow: hidden;
        margin-left: 30px;
        >div{
            width: 50%;
            float: left;
            box-sizing: border-box;
            
        }
        >div:nth-child(odd){
            padding-right: 10px;
        }
        >div:nth-child(even){
            padding-left: 10px;
        }
        p{
            color: #4d4d4d;
            line-height: 50px;
            font-size: 24px;
            padding-bottom: 20px;
            text-indent: 20px;
        }
        .item{
            overflow: hidden;
            height: 270px;
            cursor: pointer;
            img {
                transform: scale(1, 1);
                transition: all 0.3s linear;
                width: 100%;
                height: 100% !important;
            }
        }
        
        .item:hover {
            img {
                transform: scale(1.2, 1.2);
                transition: all 0.3s linear;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/apply/detail.vue